import { Customer_Invoices, Customer_InvoicesFilterDefaults } from "data/endpoints";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import React, { useEffect, useState } from "react";
import InvoiceSimplified from "../components/InvoiceSimplified";
import InvoiceSimplifiedHeader from "../components/InvoiceSimplifiedHeader";
import IExternalFilterData from "features/shared/components/dataFilter/IExternalFilterData";
import { DataGridId } from "features/shared/components/dataGrid/DataGridId";
import DataGrid from "features/shared/components/dataGrid/DataGrid";
import { loadDataFilterConfig, loadDataSortConfig } from "features/shared/helpers/modules";
import IInvoiceService from "features/invoices/services/IInvoiceService";
import { getQueryParams } from "features/shared/helpers/queryParams";
import { InvoiceType } from "features/invoices/enums/invoiceType";

const proformaInvoicesDataFilterJson = loadDataFilterConfig("proformaInvoicesDataFilter");
const proformaInvoicesDataSortJson = loadDataSortConfig("proformaInvoicesDataSort");

type Props = {}

const ProformaInvoicesSection = (props: Props) => {
  // DI
  const invoiceService = useInjection<IInvoiceService>(IocTypes.InvoiceService);

  // state
  const [externalFilterData, setExternalFilterData] = useState<IExternalFilterData<any>[]>([]);

  // helpers
  const getAndSetExternalFilterData = async () => {
    let externalData = await invoiceService.getExternalFilterData(["Proformainvoice"]);
    setExternalFilterData(externalData);
  };

  // Externí data pro filtr
  useEffect(() => {
    getAndSetExternalFilterData();
  }, []);

  // render
  return (
    <DataGrid 
      gridId={DataGridId.proformaInvoicesGrid}
      url={Customer_Invoices}
      filterJson={proformaInvoicesDataFilterJson}
      filterExternalData={externalFilterData}
      filterDefaultsUrl={Customer_InvoicesFilterDefaults}
      sortingJson={proformaInvoicesDataSortJson}
      renderItem={(item) => <InvoiceSimplified invoice={item} /> }
      renderHeader={() => <InvoiceSimplifiedHeader isProformaInvoices />}
      noFilterQueryParams={getQueryParams("InvoiceTypes", InvoiceType.Proformainvoice)}
    />
  );
}

export default ProformaInvoicesSection;